import request from '@/utils/request'
// 联登
export function unionLoginApi(data = {
    encryptData: '',
    nonceStr: '',
    timestamp: '',
    appId: '',
    channelCode: '',
    openId: ''
}) {
  data.channelCode = window.localStorage.getItem('channelCode') //'inkdb001'
  return request({
    method: 'post',
    url: '/cls/passport-personal/app/loginAndRegister/unionLogin',
    data,
  })
}
// 查询商品信息
export function userLcApplGooodsApi(data = {
    applyUserId: '',
    goodsModel: '',
    goodsModelNo: '',
  }) {
  data.channelCode = window.localStorage.getItem('channelCode') //'inkdb001'
  return request({
    method: 'post',
    url: '/cls/core/app/lcApplGoods/userLcApplGooods',
    data,
  })
}

// 经销商绑定
export function dealerBindApi(data = {
  id: '',
  status: '1',
}) {
  return request({
    method: 'post',
    url: '/cls/core/app/lcApplGoods/dealerBind',
    data,
  })
}

// 经销商绑定列表
export function dealerBindListApi(data = {
  status: '', // 0创建，1待确认，2已同意，3已拒绝，4已取消
  pageNum: 1,
  pageSize: 10
}) {
  return request({
    method: 'post',
    url: '/cls/core/app/lcApplGoods/pageList',
    data,
  })
}

// 经销商详情
export function dealerDetailApi(data = {
  id: 0, 
  loanNo: '', //借据号
}) {
  return request({
    method: 'post',
    url: '/cls/core/app/lcApplGoods/detail',
    data,
  })
}

// 首付款发短信
export function sendFstPayCodeApi(data = { loanNo: '' }) {
  return request({
    method: 'post',
    url: '/cls/core/app/fstPayRecord/sendFstPayCode',
    data,
  })
}

// 增加首付款记录（卡电宝暂时不走线上首付款支付时用20260305yb）
export function addFstPayRecordApi(data = { loanNo: '' }) {
  return request({
    method: 'post',
    url: '/cls/core/app/fstPayRecord/addFstPayRecord',
    data,
  })
}

// down payment wx jsapi pay
export function fstPayWxpayApi(data = { loanNo: '' }) {
  return request({
    method: 'post',
    url: '/cls/core/app/fstPayRecord/wxpay',
    data,
  })
}

// down payment confirm pay
export function doFstPayApi(data = { loanNo: '', phoneCode: '' }) {
  return request({
    method: 'post',
    url: '/cls/core/app/fstPayRecord/doFstPay',
    data,
  })
}


// 首付款查询结果
export function queryFstPayResultApi(data = { loanNo: ''}) {
  return request({
    method: 'post',
    url: '/cls/core/app/fstPayRecord/queryFstPayResult',
    data,
  })
}
